import React from 'react'
import styled from 'styled-components'

class Days extends React.Component {
    render() {
        const { day, schedule } = this.props;
        const { open, close } = schedule;

        return (
            <Container>
                <div>{day.toUpperCase()}:</div>
                <div>{open} - {close}</div>
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #EDEDED;
`;


export default Days